import { useContext } from "react";
import { MainContext } from "../context/MainContextProvider";
import BaseButton from "./BaseButton";
import { SxProps, Theme } from "@mui/material";

export default function PrimaryBaseButton(props: {
  title: string;
  isActive?: boolean;
  disabled?: boolean;
  loading?: boolean;
  type?: "submit" | "button" | "reset";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  variant?: "text" | "outlined" | "contained";
  heigth?: number | string;
  width?: number | string;
  sx?: SxProps<Theme>;
  href?: string;
  fontSize?: string | number | undefined
}) {
  const {
    title,
    isActive,
    disabled,
    loading,
    type,
    onClick,
    startIcon,
    endIcon,
    variant,
    heigth,
    width,
    sx,
    href,
    fontSize
  } = props;
  const { theme } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;
  return (
    <BaseButton
      href={href}
      sx={{
        borderColor: primary,
        backgroundColor: isActive ? primary : "none",
        "& .MuiTypography-root": {
          color: isActive ? "#FFFFFF" : primary,
          fontSize: fontSize
        },
        "& .MuiSvgIcon-root": {
          color: isActive ? "#FFFFFF" : primary,
          width: "20px",
          height: "20px",
        },
        width: "fit-content",
        "&:hover": {
          borderColor: primary,
          backgroundColor: primary,
          color: primary,
          "& .MuiTypography-root": {
            color: "#FFFFFF",
          },
          "& .MuiSvgIcon-root": {
            color: "#FFFFFF",
          },
        },
        ...sx,
      }}
      title={title}
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      type={type}
      startIcon={startIcon}
      endIcon={endIcon}
      variant={variant}
      heigth={heigth}
      width={width}
    />
  );
}
